import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface DocumentRejectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  fieldLabel: string;
  onConfirm: (rejectionReason: string) => void;
  isSubmitting: boolean;
  initialReason?: string;
  onReasonChange?: (reason: string) => void;
}

export function DocumentRejectionDialog({
  isOpen,
  onClose,
  fieldLabel,
  onConfirm,
  isSubmitting,
  initialReason = '',
  onReasonChange,
}: DocumentRejectionDialogProps) {
  const [localReason, setLocalReason] = useState(initialReason);

  const handleConfirm = () => {
    onConfirm(localReason.trim());
    setLocalReason('');
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setLocalReason('');
      onClose();
    }
  };

  const handleReasonChange = (value: string) => {
    setLocalReason(value);
    onReasonChange?.(value);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Reprovar documento: {fieldLabel}</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="py-4 space-y-2">
          <Label htmlFor="rejection-reason">Motivo da reprovação *</Label>
          <Textarea
            id="rejection-reason"
            placeholder="Descreva o motivo pelo qual este documento está sendo reprovado..."
            value={localReason}
            onChange={(e) => handleReasonChange(e.target.value)}
            disabled={isSubmitting}
            rows={4}
            className="resize-none"
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isSubmitting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              handleConfirm();
            }}
            disabled={isSubmitting || !localReason.trim()}
            className="bg-red-600 text-white hover:bg-red-700"
          >
            {isSubmitting ? 'Reprovando...' : 'Confirmar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
